import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Cell, Grid } from 'react-md';
import { get } from 'lodash-es';

import HiddenField from '../../Common/HiddenField';
import Select from '../../Common/Select';
import ExtendedPartyFields from './ExtendedPartyFields';
import PartyFields from './PartyFields';

const SubscriberFields = ({
  index,
  strings,
  readOnly,
  formState,
  config,
  subscriber,
  subscriptionItem,
  subscriberKind,
}) => {
  const [selectedValueSubscriber, setSelectedValueSubscriber] = useState(subscriber.subscriber);

  const values = get(formState, 'values');
  const covered = get(values, 'covered', []);
  // used party if is defined then display select
  if (Array.isArray(covered)) {
    const options = [];
    // Add covered elements
    covered.forEach((c, key) => {
      if (c.party && c.party.name && c.party.first_name && c.party.birth_date && c.party.gender) {
        options.push({
          value: key,
          text: `#${key + 1} ${c.party.first_name} ${c.party.name}`,
        });
      }
    });
    // Add default empty other subscriber
    options.push({
      value: -1,
      text: get(strings, 'block.transform.subscriber.new-subscriber', 'Autre souscripteur...'),
    });
    if (options.length > 1) {
      return (
        <Grid
          className="grid"
          style={{
            width: '100%',
          }}
        >
          <div key="name" className={`${Cell.getClassName({ size: 12 })} subscriber-fields`}>
            {subscriberKind === 'company' ? (
              <HiddenField field="subscriber" initialValue={-1} />
            ) : (
              <Select
                className="field select"
                key="subscriber"
                field="subscriber"
                id="select-subscriber"
                name="subscriber"
                shrink
                label={get(strings, 'block.transform.party.field.select.label')}
                options={options}
                onChange={value => {
                  setSelectedValueSubscriber(value);
                }}
                value={selectedValueSubscriber}
                initialValue={selectedValueSubscriber || index}
                disabled={readOnly}
              />
            )}
            {selectedValueSubscriber !== -1 ? (
              []
            ) : (
              <>
                <div className="party">
                  <PartyFields
                    subscriptionItem={subscriptionItem}
                    formState={formState}
                    strings={strings}
                    config={config}
                    readOnly={readOnly}
                    subscriberKind={subscriberKind}
                  />
                </div>
                <div className="extension">
                  <ExtendedPartyFields
                    key={`phone-email-${selectedValueSubscriber}`}
                    config={config}
                    values={get(subscriptionItem, 'subscriber')}
                    strings={strings}
                    readOnly={readOnly}
                    items={['PHONE', 'EMAIL']}
                  />
                </div>
              </>
            )}
          </div>
          <div className="extension">
            <ExtendedPartyFields
              key={`-address-${selectedValueSubscriber}`}
              config={config}
              values={get(subscriptionItem, 'subscriber')}
              strings={strings}
              readOnly={readOnly}
              items={['ADDRESS']}
            />
          </div>
        </Grid>
      );
    }
  }
  // else display empty form "party"
  return <PartyFields cellSize={12} strings={strings} config={config} readOnly={readOnly} />;
};

SubscriberFields.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  readOnly: PropTypes.bool.isRequired,
  subscriptionItem: PropTypes.shape({
    covered: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    subscriber: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  }).isRequired,
  formState: PropTypes.any.isRequired, // eslint-disable-line
  config: PropTypes.any.isRequired, // eslint-disable-line
  subscriber: PropTypes.object.isRequired, // eslint-disable-line
  index: PropTypes.number.isRequired,
  subscriberKind: PropTypes.string,
};

SubscriberFields.defaultProps = {
  strings: {},
  subscriberKind: 'all',
};

export default SubscriberFields;
